import api_client from "./api_client";
import { toast } from "react-toastify";

// 訊息中心（回覆客人 LINE 訊息）API

// 聊天室列表：type = unread(未回覆) | all(全部)，page 批次滾動載入
export const getChatsAPI = async ({ type = "unread", search = "", page = 0 } = {}) => {
  try {
    const response = await api_client.get("/chats", { params: { type, search, page } });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 聊天室訊息：不帶游標=最新一批(並標為已讀)、before_id=往上載入歷史、after_id=載入新訊息
export const getChatMessagesAPI = async ({ chat_id, before_id, after_id } = {}) => {
  try {
    const response = await api_client.get("/chat/messages", {
      params: { chat_id, before_id, after_id },
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 傳送文字或貼圖：{ chat_id, text } 或 { chat_id, sticker_id }
export const sendChatMessageAPI = async ({ chat_id, text, sticker_id }) => {
  try {
    const response = await api_client.post("/chat/send", { chat_id, text, sticker_id });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 傳送圖片（multipart）
export const sendChatImageAPI = async ({ chat_id, file }) => {
  try {
    const formData = new FormData();
    formData.append("chat_id", chat_id);
    formData.append("image", file);
    const response = await api_client.post("/chat/image", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 30000,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// 該 LINE 會員的購買紀錄，page 批次滾動載入
export const getChatOrdersAPI = async ({ chat_id, page = 0 }) => {
  try {
    const response = await api_client.get("/chat/orders", { params: { chat_id, page } });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

const handleError = (error) => {
  if (error.__handled || error.response?.status === 401) {
    throw error;
  }
  if (error.response) {
    toast.error(error.response.data.message || "伺服器錯誤");
  } else {
    toast.error("網絡錯誤");
  }
  throw error;
};
